import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuraMark, AuraWordmark } from "@/components/AuraMark";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, User, Shield, LogOut } from "lucide-react";

export const TopNav = () => {
  const { user, logout, isPrivileged } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const link = (to, label, testid) => (
    <button
      data-testid={testid}
      onClick={() => nav(to)}
      className={`px-2.5 sm:px-3 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
        loc.pathname === to ? "text-cyan bg-white/5" : "text-slate-400 hover:text-slate-100"
      }`}
    >
      {label}
    </button>
  );
  return (
    <header className="sticky top-0 z-40 glass">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-2.5 shrink-0" data-testid="nav-logo">
          <AuraMark className="w-8 h-8" />
          <AuraWordmark className="text-lg hidden sm:block" />
        </Link>
        <nav className="flex items-center gap-1 sm:gap-1.5 min-w-0">
          {user ? (
            <>
              {link("/dashboard", "Studio", "nav-dashboard")}
              {link("/profile", "Profile", "nav-profile")}
              {isPrivileged && (
                <button
                  data-testid="nav-admin"
                  onClick={() => nav("/admin")}
                  className="px-2.5 sm:px-3 py-1.5 rounded-full text-sm font-semibold text-orange flex items-center gap-1.5 hover:bg-orange-500/10 transition-colors"
                >
                  <Shield className="w-3.5 h-3.5" /> <span className="hidden sm:inline">Cockpit</span>
                </button>
              )}
              <div className="ml-2 flex items-center gap-2 pl-3 border-l border-white/10">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-8 h-8 rounded-full ring-1 ring-white/15" />
                ) : (
                  <div className="w-8 h-8 rounded-full bg-cyan-500/20 flex items-center justify-center text-cyan text-sm font-semibold">
                    {(user.name || user.email || "?")[0].toUpperCase()}
                  </div>
                )}
                <button data-testid="nav-logout" onClick={logout} className="text-slate-400 hover:text-red-400 transition-colors">
                  <LogOut className="w-4 h-4" />
                </button>
              </div>
            </>
          ) : (
            <>
              {link("/pricing", "Pricing", "nav-pricing")}
              <Button data-testid="nav-login" onClick={() => nav("/login")} className="rounded-full bg-cyan-400 text-black hover:bg-cyan-300 font-semibold ml-2">
                Sign in
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
